<template>
  <div class="account-manage">
    <div class="manage-query">
      <el-form
        :inline="true"
        :model="query"
        ref="queryForm"
        size="small"
        class="query-middle"
      >
        <el-form-item label="用户名：" prop="Uname " style="margin-right: 30px">
          <el-input v-model="query.Uname"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getMembers"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="info" icon="el-icon-circle-close" @click="clearQuery"
            >清除</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="account-title">
      账户管理
      <!-- <el-button icon="el-icon-folder-opened" @click="addAccount" size="mini"
        >新增</el-button
      > -->
    </div>
    <div class="account-table">
      <el-table :data="tableData" height="753px" border>
        <el-table-column
          type="selection"
          min-width="10"
          align="center"
        ></el-table-column>
        <el-table-column
          label="用户名"
          prop="Uname"
          min-width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          label="账户昵称"
          prop="NikeName"
          min-width="100"
          align="center"
        ></el-table-column>
        <!-- <el-table-column
          label="角色类型"
          prop="Orgs"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <p v-for="item in scope.row.Orgs" :key="item">{{ item }}</p>
          </template>
        </el-table-column> -->
        <el-table-column
          label="角色名称"
          prop="RoleNames"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <p v-for="item in scope.row.RoleNames" :key="item">{{ item }}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="所属总店"
          prop="CompanyName"
          min-width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          label="所属门店"
          prop="StoreName"
          min-width="80"
          align="center"
        ></el-table-column>
         <el-table-column label="状态" prop="Status" min-width="80" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.Status | keyToVal(statusType)"
              effect="dark"
              size="small"
            >{{scope.row.Status | keyToVal(normalStatus)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="120"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-row type="flex" class="row-bg" justify="space-around">
              <el-button
                v-if="scope.row.Status === 0"
                size="mini"
                type="primary"
                @click="editAccount(scope.row)"
                >编辑</el-button
              >
              <el-button-group>
                <el-button
                  v-if="scope.row.Status === 0"
                  size="mini"
                  type="warning"
                  @click="changeState(scope.row.Id, 1)"
                  >禁用</el-button
                >
                <el-button
                  v-if="scope.row.Status === 1"
                  size="mini"
                  type="success"
                  @click="changeState(scope.row.Id, 0)"
                  >启用</el-button
                >
                <el-popconfirm
                  title="确认删除吗？"
                  v-on:onConfirm="changeState(scope.row.Id, -1)"
                  v-if="scope.row.Status !== -1"
                >
                  <el-button size="mini" type="danger" slot="reference"
                    >删除</el-button
                  >
                </el-popconfirm>
              </el-button-group>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="account-pagination">
      <el-pagination
        class="pagination-bottom"
        background
        layout="prev, pager, next, total,sizes,jumper"
        small
        hide-on-single-page
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 20]"
        :current-page.sync="pagination.pageIndex"
        v-on:size-change="handlePageSize"
        v-on:current-change="handlePageIndex"
      ></el-pagination>
    </div>
    <!-- 新增/编辑/查看角色模态框 -->
    <el-dialog
      title="用户管理"
      :visible.sync="dialog.visible"
      :close-on-click-modal="false"
       @closed="closeDialog('memForm')"
    >
      <el-form
        :model="dialog.form"
        :rules="dialog.rules"
        ref="memForm"
        label-width="120px"
      >
        <el-form-item prop="Uname" label="用户名">
          <el-input v-model="dialog.form.Uname"></el-input>
        </el-form-item>
        <el-form-item prop="NikeName" label="账户昵称">
          <el-input v-model="dialog.form.NikeName"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="RoleId">
          <el-select
            v-model="dialog.form.RoleId"
            filterable
            placeholder="请选择"
             :disabled="true"
          >
            <el-option
              v-for="item in options.roles"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
              <span style="float: left">{{ item.Type }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.Name
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属总店" prop="Company">
          <el-select
            v-model="dialog.form.Company"
            filterable
            placeholder="请选择"
            @change="getStore"
            :disabled="true"
          >
            <el-option
              v-for="item in options.companies"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属门店" prop="Store">
          <el-select
            v-model="dialog.form.Store"
            filterable
            placeholder="请选择"
            :disabled="true"
          >
            <el-option
              v-for="item in options.stores"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('memForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { validatePassword,validateUsername,validateRegistCode,validatePhoneTwo,validateLicenseCode } from "../../common/element-validator";
import { mapState } from "vuex";
import { keyToVal } from "@/filters/filters";
import COMMON from "@/api/common";
import STORE from "@/api/store";
export default {
  name: "AccountManage",
  data() {
    return {
      query: {
        Uname: "",
      },
      dialog: {
        visible: false,
        type: "",
        form: {
          Id: "",
          Uname: "",
          NikeName: "",
          RoleId: "",
          Company: "",
          Store: "",
        },
        rules: {
          Uname: [
            { required: true, message: "用户名不为空", trigger: "blur" },
             { validator: validateUsername, trigger: "blur" },
          ],
          // NikeName: [
          //   { required: true, message: "账户昵称不为空", trigger: "blur" },
          // ],
          RoleId: [{ required: true, message: "角色不为空", trigger: "blur" }],
          // Company: [{ required: true, message: "总店不为空", trigger: "blur" }],
        },
      },
      pagination: { pageIndex: 1, pageSize: 10, total: 0 },
      tableData: [
        {
          Id: "",
          Uname: "",
          NikeName: "",
          Company: "",
          Store: "",
          RoleOrg: [],
        },
      ],
      options: {
        companies: [],
        roles: [],
        stores: [],
      },
    };
  },
  inject: ["deepClone"],
  computed: {
    ...mapState("common", ["normalStatus", "statusType"]),
  },
  filters: {
    keyToVal,
  },
  methods: {
    closeDialog(formname){
      this.$refs[formname].clearValidate();
      this.$refs[formname].resetFields();
    },
    addAccount() {
      this.dialog.type = "add";
      this.dialog.visible = true;
      this.dialog.form = {
        Id: "",
        Uname: "",
        NikeName: "",
        RoleId: "",
        Company: "",
        Store: "",
      };
    },
    editAccount(row) {
      this.dialog.type = "edit";
      this.dialog.visible = true;
      // this.dialog.form = this.deepClone(row);
      this.dialog.form ={
        Id: row.Id,
        Uname: row.Uname,
        NikeName: row.NikeName,
        RoleId: row.RoleId[0],
        Company: row.CompanyName,
        Store: row.StoreName,
      };
    },
    //提交模型
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialog.type === "add") {
            COMMON.addMember(this.dialog.form).then((res) => {
              if (res.status === "success") {
                this.$message.success("添加成功!");
                this.dialog.visible = false;
                this.getMembers();
              } else {
                this.$message.error(res.msg);
                return;
              }
            });
          } else if (this.dialog.type === "edit") {
            COMMON.updateMember(this.dialog.form).then((res) => {
              if (res.status === "success") {
                this.$message.success("修改成功!");
                this.dialog.visible = false;
                this.getMembers();
              } else {
                this.$message.error(res.msg);
                return;
              }
            });
          }
        } else {
          this.$message.error("请补全信息");
        }
      });
    },

    //获取用户列表
    getMembers() {
      COMMON.getMembers({
        Uname: this.query.Uname,
        PageIndex: this.pagination.pageIndex,
        PageSize: this.pagination.pageSize,
      }).then((res) => {
        if (res.status === "success") {
          this.pagination.total = res.content.Total;
          this.tableData = res.content.OnePageData.map((v) => {
            return {
              Id: v.Id,
              Uname: v.Uname,
              NikeName: v.NikeName,
              Company: v.Company ? v.Company.Id : "",
              CompanyName: v.Company ? v.Company.Name : "",
              Store: v.Store ? v.Store.Id : "",
              StoreName: v.Store ? v.Store.Name : "",
              Status: v.Status,
              Orgs: v.RoleOrg.map((ro) => ro.Type),
              RoleNames: v.RoleOrg.map((ro) => ro.Name),
              //RoleOrg: v.RoleOrg.map((ro) => ro.Type + "-->" + ro.Name), //部门-->部门角色 列表
              RoleId: v.RoleOrg.map((ro) => ro.Id),
            };
          });
        } else {
          this.$message.error("列表获取失败");
        }
      });
    },
    //获取角色
    getRoles() {
      COMMON.getRoles().then((res) => {
        if (res.status === "success") {
          this.options.roles = res.content;
        } else {
          this.$message.error("角色列表获取失败");
        }
      });
    },
    //获取总店/门店
    getStore(companyId) {
      if (typeof companyId === "undefined") {
        STORE.getStore().then((res) => {
          if (res.status === "success") {
            this.options.companies = res.content;
          } else {
            this.$message.error("门店获取失败");
          }
        });
      } else {
        STORE.getStore(companyId).then((res) => {
          if (res.status === "success") {
            this.options.stores = res.content;
          } else {
            this.$message.error("门店获取失败");
          }
        });
      }
    },
    //禁用，启用，删除
    changeState(Id, Status) {
      COMMON.changeMemberState({ Id, Status }).then((res) => {
        if (res.status === "success") {
          this.$message.success("操作成功!");
          this.getMembers();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    clearQuery() {
      this.query.Uname = "";
      this.getMembers();
    },
    handlePageSize(value) {
      this.pagination.pageSize = value;
    },
    handlePageIndex(value) {
      this.pagination.pageIndex = value;
    },
  },
  created() {
    this.getMembers();
    this.getRoles();
    this.getStore();
  },
  watch: {
    pagination() {
      this.getMembers();
    },
    "pagination.pageIndex":function(){
      this.getMembers();
    },
    "pagination.pageSize":function(){
      this.getMembers();
    },

  },
};
</script>
<style scoped lang="less">
.account-manage .account-title {
  height: 45px;
  padding: 5px 20px;
  background: #efefef;
  border-bottom: 1px solid #ddd;
}

.account-manage .account-table {
  height: 753px;
}
.account-manage .account-pagination {
  height: 40px;
  background: #dedede;
  text-align: center;
}
.pagination-bottom {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
</style>
